import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import EditEngineer from "./EditEngineer";
import "./ViewEngineer.css";
import apiService from "../../utils/apiservice";

// ✅ TOASTIFY
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const ViewEngineer = () => {
  const [rows, setRows] = useState([]);
  const [selectedEngineer, setSelectedEngineer] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [engineerToDelete, setEngineerToDelete] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("all");

  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Reset page when the data changes (e.g., after a delete or fetch)
  useEffect(() => {
    setPage(0);
  }, [rows.length]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ✅ Fetch Engineers from API
  useEffect(() => {
    if (selectedCustomer) {
      fetchEngineers();
    }
  }, [selectedCustomer]);
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem("accessToken");

      const res = await apiService.get(`/api/get_customers/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCustomers(res.data || []);
    } catch (error) {
      console.error("Error fetching customers:", error);
      toast.error("Failed to load customers");
    }
  };

  // const fetchEngineers = async () => {
  //   try {
  //     setLoading(true);

  //     const customerId = selectedCustomer;

  //     let approvedRes, pendingRes;

  //     if (customerId === "all") {
  //       // 👉 fetch ALL engineers (no filter)
  //       [approvedRes, pendingRes] = await Promise.all([
  //         apiService.get(`/api/get_engineers/`, { data: {} }),
  //         apiService.get(`/api/get_unassigned_engineers/`, { data: {} }),
  //       ]);
  //     } else {
  //       // 👉 fetch by customer
  //       [approvedRes, pendingRes] = await Promise.all([
  //         apiService.get(`/api/get_engineers/${customerId}/`, { data: {} }),
  //         apiService.get(`/api/get_unassigned_engineers/`, { data: {} }),
  //       ]);
  //     }

  //     const approvedEngineers = approvedRes.data.engineers.map((eng) => ({
  //       id: eng.id.id,
  //       first_name: eng.firstName,
  //       last_name: eng.lastName,
  //       email: eng.email,
  //       phone_no: eng.phone,
  //       supervisor_name: eng.parentSupervisor || "Unassigned",
  //       site_name:
  //         eng.assigned_sites && eng.assigned_sites.length > 0
  //           ? eng.assigned_sites.join(", ")
  //           : "N/A",
  //       is_approve: true,
  //     }));

  //     const pendingEngineers = pendingRes.data.data.map((eng) => ({
  //       id: eng.id,
  //       first_name: eng.first_name,
  //       last_name: eng.last_name,
  //       email: eng.email,
  //       phone_no: eng.phone_no,
  //       supervisor_name: "Unassigned",
  //       site_name: "N/A",
  //       is_approve: false,
  //     }));

  //     setRows([...pendingEngineers, ...approvedEngineers]);
  //   } catch (error) {
  //     console.error("Error fetching engineers:", error);
  //     toast.error("Failed to fetch engineers");
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const fetchEngineers = async () => {
    try {
      setLoading(true);

      const customerId = selectedCustomer;

      let response;

      // 👉 ALL engineers API
      if (customerId === "all") {
        response = await apiService.get(`/api/get_all_site_engineers/`, {
          data: {},
        });

        const allEngineers = response.data.site_engineers.map((eng) => ({
          id: eng.id,
          user_id: eng.user_id,
          first_name: eng.first_name,
          last_name: eng.last_name,
          email: eng.email,
          phone_no: eng.phone_no,
          supervisor_name: "N/A",
          site_name: "N/A",
          is_approve: eng.is_approve ?? false
        }));

        setRows(allEngineers);
      }

      // 👉 CUSTOMER-wise engineers API
      else {
        // const [approvedRes, pendingRes] = await Promise.all([
        //   apiService.get(`/api/get_engineers/${customerId}/`, { data: {} }),
        //   apiService.get(`/api/get_unassigned_engineers/`, { data: {} }),
        // ]);
        const approvedRes = await apiService.get(
          `/api/get_engineers/${customerId}/`,
          { data: {} }
        );

        const approvedEngineers = approvedRes.data.engineers.map((eng) => ({
          // id: eng.id?.id,
          id:eng.tb_id,
          user_id: eng.id?.id || eng.id?.user_id,
          first_name: eng.firstName,
          last_name: eng.lastName,
          email: eng.email,
          phone_no: eng.phone,
          supervisor_name: eng.parentSupervisor || "Unassigned",
          site_name:
            eng.assigned_sites?.length > 0
              ? eng.assigned_sites.join(", ")
              : "N/A",
          is_approve: eng.isApprove ?? false,   // ✅ IMPORTANT FIX
        }));
        // const pendingEngineers = pendingRes.data.data.map((eng) => ({
        //   id: eng.id,
        //   user_id: eng.user_id,
        //   first_name: eng.first_name,
        //   last_name: eng.last_name,
        //   email: eng.email,
        //   phone_no: eng.phone_no,
        //   supervisor_name: "Unassigned",
        //   site_name: "N/A",
        //   is_approve: false,
        // }));

        // setRows([...pendingEngineers, ...approvedEngineers]);
        setRows(approvedEngineers);
      }
    } catch (error) {
      console.error("Error fetching engineers:", error);
      toast.error("Failed to fetch engineers");
    } finally {
      setLoading(false);
    }
  };


  // useEffect(() => {
  //   if (selectedCustomer) {
  //     fetchEngineers();
  //   }
  // }, [selectedCustomer]);

  const handleApprove = async (engineer) => {
    try {
      const token = localStorage.getItem("accessToken");

      await axios({
        url: `${API_URL}/api/approve_engineer/${engineer.id}/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      });

      toast.success("Engineer Approved Successfully");

      // 🔥 Refresh list
      fetchEngineers();
    } catch (error) {
      console.error("Approve error:", error);
      toast.error(error.response?.data?.error || "Approval failed");
    }
  };

  // --- Edit Logic ---
  const handleEditClick = (engineer) => {
    setSelectedEngineer(engineer);
    setEditOpen(true);
  };
  const handleSaveEdit = async (updatedEngineer) => {
    try {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        toast.error("Session expired. Please login again.");
        return;
      }

      const response = await axios({
        url: `${API_URL}/api/update_engineer/${updatedEngineer.user_id}/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          first_name: updatedEngineer.first_name,
          last_name: updatedEngineer.last_name,
          phone_no: updatedEngineer.phone_no,
          email: updatedEngineer.email,
        },
      });

      console.log("Update Response:", response.data);

      // ✅ Refresh list after update
      await fetchEngineers();

      setEditOpen(false);
      setSelectedEngineer(null);

      toast.success("Engineer updated successfully!");
    } catch (error) {
      console.error("Update Error:", error);

      if (error.response?.status === 401) {
        toast.error("Unauthorized! Please login again.");
      } else {
        toast.error(error.response?.data?.error || "Update failed");
      }
    }
  };
  // --- Delete Logic ---
  const handleDeleteClick = (engineer) => {
    setEngineerToDelete(engineer);
    setDeleteOpen(true);
    setDeleteMessage("");
    setDeleteError(false);
  };

  const handleConfirmDelete = async () => {
    if (!engineerToDelete) return;

    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios({
        url: `${API_URL}/api/delete_engineer/${engineerToDelete.user_id}/`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      });

      // ✅ Use backend message
      const msg = response.data?.message || "Engineer deleted successfully";

      toast.success("Site Engineer Deleted Successfully"); // ✅ clean toast

      // ✅ Refresh table
      await fetchEngineers();

      // ✅ Close dialog
      setDeleteOpen(false);
    } catch (error) {
      console.error("Delete Error:", error);

      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Delete failed";

      toast.error(backendMessage);

      setDeleteOpen(false);
    }
  };

  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteMessage("");
    setDeleteError(false);
  };

  return (
    <Box className="view-engineer-container">
      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 2 }}>

        <select
          value={selectedCustomer}
          onChange={(e) => setSelectedCustomer(e.target.value)}
          style={{
            padding: "8px",
            minWidth: "250px",
            borderRadius: "6px",
          }}
        >
          <option value="all">All</option>

          {customers.map((cust) => (
            <option key={cust.id} value={cust.tb_customer_id}>
              {cust.customer_name}
            </option>
          ))}
        </select>
      </Box>
      <TableContainer component={Paper} className="engineer-table-wrapper">
        <Table className="engineer-table" stickyHeader sx={{
          minWidth: 900,   // ✅ IMPORTANT → forces horizontal scroll
        }}>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Assigned Site</TableCell>
              {/* <TableCell>Supervisor</TableCell> */}
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                  Loading engineers...
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={8}
                  align="center"
                  sx={{ py: 5, fontWeight: 500 }}
                >
                  No Engineers Are Available
                </TableCell>
              </TableRow>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row.id} hover>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{row.first_name}</TableCell>
                    <TableCell>{row.last_name}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.phone_no}</TableCell>
                    <TableCell>
                      <Box className="site-badge">{row.site_name}</Box>
                    </TableCell>
                    {/* <TableCell>{row.supervisor_name}</TableCell> */}
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        onClick={() => handleEditClick(row)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteClick(row)}
                      >
                        <DeleteIcon />
                      </IconButton>

                      {!row.is_approve ? (
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            ml: 1,
                            backgroundColor: "#fbc02d",
                            color: "#000",
                            "&:hover": { backgroundColor: "#f9a825" },
                          }}
                          onClick={() => handleApprove(row)}
                        >
                          Approve
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            ml: 1,
                            backgroundColor: "#58de5f",
                            "&:hover": { backgroundColor: "#58de5f" },
                          }}
                        >
                          Approved
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>

       
      </TableContainer>

       {/* Add this after </TableContainer> */}
        {!loading && rows.length > 0 && (
          <div className="pagination-bar">
            <div className="rows-select">
              Rows per page:
              <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
              </select>
            </div>
            <div className="page-info">
              {page * rowsPerPage + 1}-
              {Math.min((page + 1) * rowsPerPage, rows.length)} of {rows.length}
            </div>
            <div className="page-arrows">
              <button disabled={page === 0} onClick={() => setPage(page - 1)}>
                ‹
              </button>
              <button
                disabled={(page + 1) * rowsPerPage >= rows.length}
                onClick={() => setPage(page + 1)}
              >
                ›
              </button>
            </div>
          </div>
        )}

      {/* Edit Modal */}
      {selectedEngineer && (
        <EditEngineer
          open={editOpen}
          onClose={() => setEditOpen(false)}
          engineer={selectedEngineer}
          onSave={handleSaveEdit}
        />
      )}

      {/* Delete Dialog */}
      <Dialog open={deleteOpen} onClose={handleCancelDelete}>
        <DialogTitle>Delete Engineer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete{" "}
            <b>
              {engineerToDelete?.first_name} {engineerToDelete?.last_name}
            </b>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete}>Cancel</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer position="top-right" autoClose={3000} theme="light" />
    </Box>
  );
};

export default ViewEngineer;
